var render, staticRenderFns
import script from "./trafficSourceChartSocial.vue?vue&type=script&lang=js"
export * from "./trafficSourceChartSocial.vue?vue&type=script&lang=js"
import style0 from "./trafficSourceChartSocial.vue?vue&type=style&index=0&id=60c9055a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c9055a",
  null
  
)

export default component.exports